import React from "react";
import { useParams } from "react-router-dom";
import CountrySelect from "./CountrySelect";
import ChinaPayout from "./countries/China";
import IndiaPayout from "./countries/India";
import IndonesiaPayout from "./countries/Indonesia";
import PhilippinesPayout from "./countries/Philippines";
import UAEPayout from "./countries/UAE";

const PayToAsia: React.FC = () => {
  const { countryCode } = useParams<{ countryCode?: string }>();

  if (!countryCode) {
    return <CountrySelect />;
  }

  switch (countryCode.toLowerCase()) {
    case "cny":
      return <ChinaPayout />;
    case "inr":
      return <IndiaPayout />;
    case "idr":
      return <IndonesiaPayout />;
    case "php":
      return <PhilippinesPayout />;
    case "aed":
      return <UAEPayout />;
    default:
      return <CountrySelect />;
  }
};

export default PayToAsia;
